var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M4.49977 4V1C4.49977 0.723935 4.72373 0.500125 4.99977 0.5C5.27591 0.5 5.49977 0.723858 5.49977 1V4L5.49733 4.09375C5.48368 4.31278 5.42178 4.52649 5.31617 4.71973L2.56129 9.75977C2.51963 9.83592 2.49827 9.922 2.49977 10.0088C2.50129 10.0955 2.5254 10.1803 2.56959 10.2549C2.61385 10.3295 2.6768 10.3916 2.75221 10.4346C2.82761 10.4775 2.913 10.5 2.99977 10.5H9.00026C9.08701 10.5 9.17242 10.4775 9.24782 10.4346C9.32321 10.3916 9.38618 10.3295 9.43043 10.2549C9.47463 10.1803 9.49873 10.0955 9.50026 10.0088C9.50175 9.922 9.4804 9.83592 9.43873 9.75977L6.68385 4.71973C6.57824 4.52649 6.51635 4.31278 6.5027 4.09375L6.49977 4V1C6.49977 0.723935 6.72373 0.500125 6.99977 0.5C7.27591 0.5 7.49977 0.723858 7.49977 1V4C7.49973 4.08387 7.52107 4.16664 7.56129 4.24023L10.3157 9.27978C10.4407 9.50824 10.5043 9.7655 10.4998 10.0259C10.4953 10.2863 10.4231 10.5411 10.2903 10.7651C10.1575 10.989 9.96866 11.1744 9.74244 11.3032C9.51615 11.4321 9.26019 11.5001 8.99977 11.5H2.99977V11.4995C2.73947 11.4995 2.48377 11.432 2.25758 11.3032C2.03135 11.1744 1.84254 10.989 1.70973 10.7651C1.57692 10.5411 1.50426 10.2863 1.49977 10.0259C1.49528 9.76551 1.55885 9.50823 1.68385 9.27978H1.68434L4.43873 4.24023C4.47896 4.16664 4.4998 4.08387 4.49977 4Z",
    fill: "#C11E05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    d: "M8.77338 7C9.04952 7 9.27338 7.22386 9.27338 7.5C9.27338 7.77614 9.04952 8 8.77338 8H3.2265C2.95036 8 2.7265 7.77614 2.7265 7.5C2.7265 7.22386 2.95036 7 3.2265 7H8.77338Z",
    fill: "#C11E05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    d: "M7.75 0.5C8.02614 0.5 8.25 0.723858 8.25 1C8.25 1.27614 8.02614 1.5 7.75 1.5H4.25C3.97386 1.5 3.75 1.27614 3.75 1C3.75 0.723858 3.97386 0.5 4.25 0.5H7.75Z",
    fill: "#C11E05"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.e78ee6992742e91d8578c8002f26468b.svg";
export { ForwardRef as ReactComponent };